import {
  GET_HISTORIQUES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  historiques: [],
  error: {},
};

const Historique = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_HISTORIQUES:
          return {
            ...state,
            historiques: action.payload.data,
            isHistoriqueSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_HISTORIQUES:
          return {
            ...state,
            error: action.payload.error,
            isHistoriqueSuccess: false
          };
        
        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Historique;
